export default "__VITE_ASSET__DrRZR2zS__"